
/**
 * @param {monaco.editor.IStandaloneCodeEditor} editor
 */
export async function insertLink(editor, url) {
	const range = editor.getSelection();

	if (range.startLineNumber !== range.endLineNumber) {
		return;
	}

	const text = editor.getModel().getValueInRange(range) || url;

	return editor.executeEdits("insert-link", [{
		identifier: 'insert',
		range,
		text: `[${text}](${url})`,
		forceMoveMarkers: true
	}]);
}



// WEBPACK FOOTER //
// ./lib/editor/MarkdownEditor/actions/insertLink.js